export const ExtensionsArr = [
  // "/extensions/ComfyI2I/ComfyShop.js",
  // "/extensions/ComfyI2I/imageProcessorWorker.js",
  // "/extensions/dzNodes/dz_parse-css.js",
  // "/extensions/dzNodes/dz_mtb_widgets.js",
  // "/extensions/dzNodes/dz_node_palette.js",
  // "/extensions/dzNodes/dz_debug.js",
  // "/extensions/dzNodes/dz_comfy_shared.js",
  // "/extensions/ComfyLiterals/operation-node.js",
  // "/extensions/mtb/dz_parse-css.js",
  // "/extensions/mtb/dz_mtb_widgets.js",
  // "/extensions/mtb/dz_debug.js",
  // "/extensions/mtb/dz_comfy_shared.js",
  // "/extensions/jake_upgrade/jake_upgrade.js",
  // "/extensions/Gemini_Zho/GeminiAPINode.js",
  // "/extensions/EG_GN_NODES/wbksh.js",
  "/extensions/ComfyUI-utils-nodes/js/previewText.js",
  // "/extensions/ZHO/mtb_widgets.js",
  // "/extensions/ZHO/comfy_shared.js",
  // "/extensions/ZHO/debug.js",
  // "/extensions/ZHO/parse-css.js",
  // "/extensions/jjk_util/jjkShowText.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/ide_node.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/utils.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/deep_translator_node.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/google_translate_node.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/argos_tranlsate_node.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/painter_node.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/extras_node.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/pose_node.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/extrasnode/extras_node_dialogs.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/extrasnode/extras_node_widgets.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/mode-python.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-themelist.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-idle_fingers.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-solarized_dark.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-monokai.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-language_tools.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-whitespace.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-tomorrow_night_blue.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-hardwrap.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-textmate.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-emmet.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-clouds_midnight.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-spellcheck.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-merbivore_soft.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-textarea.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-mono_industrial.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-github.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-beautify.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-gob.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-chrome.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-eclipse.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-dracula.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-elastic_tabstops_lite.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-command_bar.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-settings_menu.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-simple_tokenizer.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-kr_theme.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-gruvbox_light_hard.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/mode-javascript.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-twilight.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-solarized_light.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/keybinding-sublime.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-modelist.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-linking.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-one_dark.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-options.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-error_marker.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-nord_dark.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-chaos.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-vibrant_ink.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-searchbox.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-github_dark.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-sqlserver.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-split.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-static_highlight.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-inline_autocomplete.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-tomorrow_night_bright.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-github_light_default.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-statusbar.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-dawn.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/keybinding-vim.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-keybinding_menu.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-dreamweaver.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-cloud9_night_low_color.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-xcode.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-gruvbox.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/worker-javascript.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-kuroir.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-katzenmilch.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-gruvbox_dark_hard.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-crimson_editor.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-cloud_editor.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-cloud9_day.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-iplastic.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-code_lens.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-tomorrow_night.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/keybinding-emacs.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/keybinding-vscode.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-tomorrow.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-pastel_on_dark.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-prompt.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-cloud_editor_dark.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-merbivore.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-cloud9_night.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-clouds.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ext-rtl.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-ambiance.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-terminal.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-cobalt.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/ace.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/theme-tomorrow_night_eighties.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/snippets/python.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/idenode/ace-builds/src-min-noconflict/snippets/javascript.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/painternode/fabric.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/painternode/brushes.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/painternode/helpers.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/painternode/manager_mypaint.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/painternode/mybrush.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/painternode/dialogs.js",
  "/extensions/ComfyUI_Custom_Nodes_AlekPet/lib/posenode/fabric.js",
  "/extensions/canvas_tab/main.js",
  "/extensions/canvas_tab/page/cash.min.js",
  "/extensions/canvas_tab/page/support.js",
  "/extensions/canvas_tab/page/paintTools.js",
  "/extensions/canvas_tab/page/bspaint.js",
  "/extensions/canvas_tab/page/main.js",
  "/extensions/ComfyUI_ColorMod/ColorMod.js",
  "/extensions/Derfuu_ComfyUI_ModdedNodes/debugNode.js",
  "/extensions/ComfyUI-Impact-Pack/common.js",
  "/extensions/ComfyUI-Impact-Pack/impact-image-util.js",
  "/extensions/ComfyUI-Impact-Pack/impact-pack.js",
  "/extensions/ComfyUI-Impact-Pack/impact-sam-editor.js",
  "/extensions/ComfyUI-Impact-Pack/impact-segs-picker.js",
  "/extensions/ComfyUI-Impact-Pack/mask-rect-area-advanced.js",
  "/extensions/ComfyUI-Impact-Pack/mask-rect-area.js",
  "/extensions/comfyui-art-venture/text-switch-case.js",
  "/extensions/comfyui-art-venture/upload.js",
  "/extensions/comfyui-art-venture/utils.js",
  "/extensions/ComfyUI_Qwen2-VL-Instruct/js/multiplePathsInput.js",
  "/extensions/img2txt-comfyui-nodes/show-output-text.js",
  "/extensions/ComfyUI-AnimateDiff-Evolved/js/autosize.js",
  "/extensions/ComfyUI-AnimateDiff-Evolved/js/gif_preview.js",
  "/extensions/ComfyUI-AnimateDiff-Evolved/js/deprecate_nodes.js",
  "/extensions/ComfyUI-AnimateDiff-Evolved/js/documentation.js",
  // "/extensions/aegisflow_utility_nodes/NodeTemplate.js",
  "/extensions/ComfyUI_omost/omost_canvas_editor_index.js",
  "/extensions/ComfyUI-KJNodes/js/browserstatus.js",
  "/extensions/ComfyUI-KJNodes/js/spline_editor.js",
  "/extensions/ComfyUI-KJNodes/js/contextmenu.js",
  "/extensions/ComfyUI-KJNodes/js/jsnodes.js",
  "/extensions/ComfyUI-KJNodes/js/fast_preview.js",
  "/extensions/ComfyUI-KJNodes/js/point_editor.js",
  "/extensions/ComfyUI-KJNodes/js/help_popup.js",
  "/extensions/ComfyUI-KJNodes/js/appearance.js",
  "/extensions/ComfyUI-KJNodes/js/setgetnodes.js",
  // "/extensions/ComfyUI-Lora-Auto-Trigger-Words/js/loraInfo.js",
  // "/extensions/ComfyUI-JNodes/js/EditAttention.js",
  // "/extensions/ComfyUI-JNodes/js/StatusProgressBar.js",
  // "/extensions/ComfyUI-JNodes/js/BatchCommenting.js",
  // "/extensions/ComfyUI-JNodes/js/StatusFavicon.js",
  // "/extensions/ComfyUI-JNodes/js/TextareaFontControl.js",
  // "/extensions/ComfyUI-JNodes/js/StatusTitle.js",
  // "/extensions/ComfyUI-JNodes/js/CtrlShiftToPanFaster.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ImageDrawerMain.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ContextSelector.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ImageDrawerSearch.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ImageDrawerListSorting.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/Contexts.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/CSS.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ImageDrawerList.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/Core/ImageDrawerModule.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/BasicOptionManagerButtons/BatchRemovalManager.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/BasicOptionManagerButtons/BatchFavouriteManager.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/BasicOptionManagerButtons/BatchDeletionManager.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/BasicOptionManagerButtons/BatchSelectionManager.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/BasicOptionManagerButtons/BatchOptionManagerButton.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ImageListChildElements/ImageListChildElementUtils.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ImageListChildElements/ExtraNetworks.js",
  // "/extensions/ComfyUI-JNodes/js/ImageDrawer/ImageListChildElements/ImageElements.js",
  // "/extensions/ComfyUI-JNodes/js/nodes/SyncedStringLiteral.js",
  // "/extensions/ComfyUI-JNodes/js/nodes/MetadataNodes.js",
  // "/extensions/ComfyUI-JNodes/js/nodes/SubdirectorySelector.js",
  // "/extensions/ComfyUI-JNodes/js/nodes/TokenCount.js",
  // "/extensions/ComfyUI-JNodes/js/nodes/VideoUpload.js",
  // "/extensions/ComfyUI-JNodes/js/nodes/VideoPreview.js",
  // "/extensions/ComfyUI-JNodes/js/nodes/MediaMetadata.js",
  // "/extensions/ComfyUI-JNodes/js/common/SettingsManager.js",
  // "/extensions/ComfyUI-JNodes/js/common/EventManager.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExtensionManager.js",
  // "/extensions/ComfyUI-JNodes/js/common/Spinner.js",
  // "/extensions/ComfyUI-JNodes/js/common/VideoOptions.js",
  // "/extensions/ComfyUI-JNodes/js/common/VideoControl.js",
  // "/extensions/ComfyUI-JNodes/js/common/SortTypes.js",
  // "/extensions/ComfyUI-JNodes/js/common/ImageAndVideoObserver.js",
  // "/extensions/ComfyUI-JNodes/js/common/Utilities.js",
  // "/extensions/ComfyUI-JNodes/js/common/SearchableDropDown.js",
  // "/extensions/ComfyUI-JNodes/js/common/ModalManager.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/image-header-png.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/errors.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/png-file-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/icc-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/iptc-tag-names.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names-gps-ifd.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/utils.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/iptc-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names-common.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/dataview.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/image-header-jpeg.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/image-header-heic.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/thumbnail.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names-exif-ifd.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/mpf-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/image-header-webp.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/icc-tag-names.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tags-helpers.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/xmp-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names-0th-ifd.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/png-text-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/constants.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/exif-reader.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names-interoperability-ifd.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names-mpf-ifd.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/types.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/image-header.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-names-utils.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/vp8x-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/png-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/file-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/jfif-tags.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/tag-decoder.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/text-decoder.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/xmp-tag-names.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/byte-order.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/image-header-tiff.js",
  // "/extensions/ComfyUI-JNodes/js/common/ExifReader-main/src/dom-parser.js",
  "/extensions/CosyVoice-ComfyUI/js/uploadSRT.js",
  "/extensions/ComfyUI_smZNodes/exif.js",
  "/extensions/ComfyUI_smZNodes/smZdynamicWidgets.js",
  "/extensions/ComfyUI_smZNodes/metadata.js",
  "/extensions/ComfyUI-WD14-Tagger/js/wd14tagger.js",
  "/extensions/ComfyUI-LivePortraitNode/js/previewVideo.js",
  "/extensions/ComfyUI-LivePortraitNode/js/uploadVideo.js",
  "/extensions/ComfyUI-Inpaint-CropAndStitch/showcontrol.js",
  "/extensions/rgthree-comfy/reroute.js",
  "/extensions/rgthree-comfy/base_any_input_connected_node.js",
  "/extensions/rgthree-comfy/image_inset_crop.js",
  "/extensions/rgthree-comfy/menu_copy_image.js",
  "/extensions/rgthree-comfy/dynamic_context_switch.js",
  "/extensions/rgthree-comfy/utils.js",
  "/extensions/rgthree-comfy/display_any.js",
  "/extensions/rgthree-comfy/fast_actions_button.js",
  "/extensions/rgthree-comfy/label.js",
  "/extensions/rgthree-comfy/feature_import_individual_nodes.js",
  "/extensions/rgthree-comfy/utils_widgets.js",
  "/extensions/rgthree-comfy/node_collector.js",
  "/extensions/rgthree-comfy/random_unmuter.js",
  "/extensions/rgthree-comfy/comfy_ui_bar.js",
  "/extensions/rgthree-comfy/utils_menu.js",
  "/extensions/rgthree-comfy/menu_auto_nest.js",
  "/extensions/rgthree-comfy/constants.js",
  "/extensions/rgthree-comfy/fast_groups_bypasser.js",
  "/extensions/rgthree-comfy/node_mode_repeater.js",
  "/extensions/rgthree-comfy/dynamic_context.js",
  "/extensions/rgthree-comfy/rgthree.js",
  "/extensions/rgthree-comfy/any_switch.js",
  "/extensions/rgthree-comfy/image_comparer.js",
  "/extensions/rgthree-comfy/dynamic_context_base.js",
  "/extensions/rgthree-comfy/utils_canvas.js",
  "/extensions/rgthree-comfy/node_mode_relay.js",
  "/extensions/rgthree-comfy/menu_queue_node.js",
  "/extensions/rgthree-comfy/bookmark.js",
  "/extensions/rgthree-comfy/muter.js",
  "/extensions/rgthree-comfy/config.js",
  "/extensions/rgthree-comfy/context.js",
  "/extensions/rgthree-comfy/power_lora_loader.js",
  "/extensions/rgthree-comfy/base_node.js",
  "/extensions/rgthree-comfy/power_prompt.js",
  "/extensions/rgthree-comfy/base_power_prompt.js",
  "/extensions/rgthree-comfy/fast_groups_muter.js",
  "/extensions/rgthree-comfy/seed.js",
  "/extensions/rgthree-comfy/base_node_mode_changer.js",
  "/extensions/rgthree-comfy/base_node_collector.js",
  "/extensions/rgthree-comfy/bypasser.js",
  "/extensions/rgthree-comfy/dialog_info.js",
  "/extensions/rgthree-comfy/feature_group_fast_toggle.js",
  "/extensions/rgthree-comfy/utils_inputs_outputs.js",
  "/extensions/rgthree-comfy/services/bookmarks_services.js",
  "/extensions/rgthree-comfy/services/key_events_services.js",
  "/extensions/rgthree-comfy/services/fast_groups_service.js",
  "/extensions/rgthree-comfy/services/context_service.js",
  "/extensions/rgthree-comfy/services/config_service.js",
  "/extensions/save-image-extended-comfyui/js/marked.min.js",
  "/extensions/save-image-extended-comfyui/js/contextmenu.js",
  "/extensions/save-image-extended-comfyui/js/shared_utils.js",
  "/extensions/save-image-extended-comfyui/js/help_popup.js",
  "/extensions/save-image-extended-comfyui/js/purify.min.js",
  "/extensions/efficiency-nodes-comfyui/appearance.js",
  "/extensions/efficiency-nodes-comfyui/gif_preview.js",
  "/extensions/efficiency-nodes-comfyui/previewfix.js",
  "/extensions/efficiency-nodes-comfyui/workflowfix.js",
  "/extensions/efficiency-nodes-comfyui/widgethider.js",
  "/extensions/efficiency-nodes-comfyui/seedcontrol.js",
  "/extensions/efficiency-nodes-comfyui/node_options/swapLoaders.js",
  "/extensions/efficiency-nodes-comfyui/node_options/swapSamplers.js",
  "/extensions/efficiency-nodes-comfyui/node_options/modelInfo.js",
  "/extensions/efficiency-nodes-comfyui/node_options/swapScripts.js",
  "/extensions/efficiency-nodes-comfyui/node_options/addXYinputs.js",
  "/extensions/efficiency-nodes-comfyui/node_options/setResolution.js",
  "/extensions/efficiency-nodes-comfyui/node_options/addLinks.js",
  "/extensions/efficiency-nodes-comfyui/node_options/addScripts.js",
  "/extensions/efficiency-nodes-comfyui/node_options/swapXYinputs.js",
  "/extensions/efficiency-nodes-comfyui/node_options/common/utils.js",
  "/extensions/efficiency-nodes-comfyui/node_options/common/modelInfoDialog.js",
  "/extensions/ComfyUI-JDCN/util.js",
  "/extensions/ComfyUI-mxToolkit/StopProc.js",
  "/extensions/ComfyUI-mxToolkit/Slider.js",
  "/extensions/ComfyUI-mxToolkit/Slider2D.js",
  "/extensions/ComfyUI-mxToolkit/Seed.js",
  "/extensions/ComfyUI-mxToolkit/Reroute.js",
  "/extensions/qq-nodes-comfyui/extension.js",
  
  "/extensions/ComfyUI-Easy-Use/easyuse.js",
  "/extensions/ComfyUI-Easy-Use/assets/extensions-Bf-0b_E3.js",
  "/extensions/ComfyUI-Easy-Use/assets/lodash-CZi7izHi.js",
  "/extensions/ComfyUI-Easy-Use/assets/primeuix-iiPAZJA6.js",
  "/extensions/ComfyUI-Easy-Use/assets/primevue-Bhb8d6zf.js",
  "/extensions/ComfyUI-Easy-Use/assets/vendor-Dqa9Pnr9.js",
  "/extensions/ComfyUI-Easy-Use/assets/vue-C5MjgCre.js",

  "/extensions/ComfyUI-VideoHelperSuite/js/VHS.core.js",
  "/extensions/ComfyUI-VideoHelperSuite/js/videoinfo.js",
  "/extensions/ComfyUI-enricos-nodes/fabric.js",
  "/extensions/ComfyUI-enricos-nodes/compositor.js",
  "/extensions/ComfyUI-enricos-nodes/compositor3.js",
  "/extensions/ComfyUI-enricos-nodes/tools.js",
  "/extensions/ComfyUI-ppm/attention_couple_ppm.js",
  "/extensions/ComfyUI-Chibi-Nodes/chibi_nodes.js",
  "/extensions/ComfyUI_Fill-Nodes/FL_SystemCheck.js",
  "/extensions/ComfyUI_Fill-Nodes/PhotoPea.js",
  "/extensions/ComfyUI_Fill-Nodes/betterCombos.js",
  "/extensions/ComfyUI_Fill-Nodes/appearance.js",
  "/extensions/ComfyUI_Fill-Nodes/widget.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_BulletHell.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/fl_code_node.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_ColorPicker.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_Dalle3.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_ImageAdjuster.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/fl_js.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_LoadImage.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_NodeLoader.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_NodePackLoader.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_PixelArtNode.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_SaveImages.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_SaveWebpImages.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_Switch_Big.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_Switch.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_TetrisGame.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/FL_TimeLine.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/fl_wf_agent.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/GradientImageGenerator.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/paste-on-canvas-preview.js",
  "/extensions/ComfyUI_Fill-Nodes/nodes/SaveAndDisplayImage.js",

  "/extensions/ComfyUI_MiniCPM-V-2_6-int4/js/previewVideo.js",
  "/extensions/ComfyUI_MiniCPM-V-2_6-int4/js/displayText.js",
  "/extensions/ComfyUI_MiniCPM-V-2_6-int4/js/multipleImagesInput.js",
  "/extensions/ComfyUI_MiniCPM-V-2_6-int4/js/uploadVideo.js",
  "/extensions/ComfyUI_MaraScott_Nodes/helper.js",
  "/extensions/ComfyUI_MaraScott_Nodes/TextConcatenate_v1.js",
  "/extensions/ComfyUI_MaraScott_Nodes/DisplayInfo_v2.js",
  "/extensions/ComfyUI_MaraScott_Nodes/McBoaty_v4.js",
  "/extensions/ComfyUI_MaraScott_Nodes/AnyBus_v2.js",
  "/extensions/ComfyUI_MaraScott_Nodes/McBoaty_v5.js",
  // "/extensions/ComfyUI-Inspire-Pack/common.js",
  // "/extensions/ComfyUI-Inspire-Pack/prompt.js",
  // "/extensions/ComfyUI-Inspire-Pack/regional.js",
  // "/extensions/ComfyUI-Inspire-Pack/lora_block_weight.js",
  // "/extensions/ComfyUI-Inspire-Pack/inspire-flex.js",
  // "/extensions/ComfyUI-Inspire-Pack/inspire-pack.js",
  // "/extensions/ComfyUI-Inspire-Pack/inspire-backend.js",
  // "/extensions/ComfyUI-Inspire-Pack/seed.js",
  // "/extensions/ComfyUI-Inspire-Pack/image_util.js",
  "/extensions/comfyui_bmad_nodes/RequestInputs.js",
  "/extensions/comfyui_bmad_nodes/AnyToAny.js",
  "/extensions/comfyui_bmad_nodes/Warnings.js",
  "/extensions/comfyui_bmad_nodes/ArbitraryOutputsFixedInputs.js",
  "/extensions/comfyui_bmad_nodes/SetRequestStateToComplete.js",
  "/extensions/comfyui_bmad_nodes/ConditioningCombineMultiple.js",
  "/extensions/comfyui_bmad_nodes/ArbitraryInputsFixedOutputs.js",
  "/extensions/comfyui_bmad_nodes/AddString2Many.js",
  "/extensions/comfyui_bmad_nodes/ConditioningGrid.js",
  "/extensions/comfyui-animatediff/js/vid_upload.js",
  "/extensions/comfyui-animatediff/js/vid_preview.js",
  "/extensions/ComfyUI-Crystools/progressBar.js",
  "/extensions/ComfyUI-Crystools/utils.js",
  "/extensions/ComfyUI-Crystools/extensions.js",
  "/extensions/ComfyUI-Crystools/common.js",
  "/extensions/ComfyUI-Crystools/progressBarUIBase.js",
  // "/extensions/ComfyUI-Crystools/monitor.js",
  "/extensions/ComfyUI-Crystools/debugger.js",
  // "/extensions/ComfyUI-Crystools/monitorUI.js",
  "/extensions/ComfyUI-Crystools/progressBarUI.js",
  "/extensions/ComfyUI-Crystools/styles.js",
  "/extensions/ComfyUI-Crystools/comfy/liteGraph.js",
  "/extensions/ComfyUI-Crystools/comfy/scripts.js",
  "/extensions/ComfyUI-Crystools/comfy/liteGraph.js",
  "/extensions/ComfyUI-Crystools/comfy/index.js",
  "/extensions/ComfyUI-Advanced-ControlNet/js/autosize.js",
  "/extensions/ComfyUI-Advanced-ControlNet/js/documentation.js",
  "/extensions/ComfyUI-MimicMotion/js/previewVideo.js",
  "/extensions/ComfyUI-MimicMotion/js/uploadVideo.js",
  // "/extensions/ComfyUI-Crystools-save/common.js",
  // "/extensions/ComfyUI-Crystools-save/workflow.js",
  "/extensions/ComfyUI-SuperBeasts/superbeasts.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNinterface.js",
  "/extensions/ComfyUI_tinyterraNodes/utils.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNxyPlotAdv.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNdynamicWidgets.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNxyPlot.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNwidgets.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNembedAC.js",
  "/extensions/ComfyUI_tinyterraNodes/ttN.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNdropdown.js",
  "/extensions/ComfyUI_tinyterraNodes/ttNfullscreen.js",
  "/extensions/cg-use-everywhere/use_everywhere_classes.js",
  "/extensions/cg-use-everywhere/ue_debug.js",
  "/extensions/cg-use-everywhere/use_everywhere_graph_analysis.js",
  "/extensions/cg-use-everywhere/use_everywhere.js",
  "/extensions/cg-use-everywhere/use_everywhere_cache.js",
  "/extensions/cg-use-everywhere/use_everywhere_nodes.js",
  "/extensions/cg-use-everywhere/use_everywhere_apply.js",
  // "/extensions/cg-use-everywhere/use_everywhere_autoprompt.js",
  "/extensions/cg-use-everywhere/use_everywhere_settings.js",
  "/extensions/cg-use-everywhere/use_everywhere_utilities.js",
  "/extensions/cg-use-everywhere/use_everywhere_ui.js",
  "/extensions/ComfyUI_3dPoseEditor/openposeeditor.js",
  "/extensions/ComfyUI_3dPoseEditor/js/main.js",
  // "/extensions/comfyui_LLM_party/showtext_party.js",
  // "/extensions/comfyui_LLM_party/botton_party.js",
  "/extensions/comfyui_lists_cartesian_product/any_cartesian_product.js",
  "/extensions/ComfyUI-Mana-Nodes/js/vid_upload.js",
  "/extensions/ComfyUI-Mana-Nodes/js/text_preview.js",
  "/extensions/ComfyUI-Mana-Nodes/js/vid_preview.js",
  "/extensions/ComfyUI-Mana-Nodes/js/scheduled_values.js",
  "/extensions/bilbox-comfyui/reboot.js",
  "/extensions/bilbox-comfyui/bilboxContextMenuEnhance.js",
  "/extensions/ComfyUI-Embedding_Picker/quickNodes.js",
  "/extensions/comfyui-tooling-nodes/external_tooling_nodes.js",
  // "/extensions/ComfyUI-0246/js/fixes.js",
  // "/extensions/ComfyUI-0246/js/utils.js",
  // "/extensions/ComfyUI-0246/js/nodes.js",
  // "/extensions/ComfyUI-0246/js/widgets.js",
  "/extensions/ComfyUI-Custom-Scripts/js/middleClickAddDefaultNode.js",
  // "/extensions/ComfyUI-Custom-Scripts/js/autocompleter.js",
  "/extensions/ComfyUI-Custom-Scripts/js/quickNodes.js",
  "/extensions/ComfyUI-Custom-Scripts/js/snapToGridGuide.js",
  "/extensions/ComfyUI-Custom-Scripts/js/playSound.js",
  "/extensions/ComfyUI-Custom-Scripts/js/repeater.js",
  "/extensions/ComfyUI-Custom-Scripts/js/contextMenuHook.js",
  "/extensions/ComfyUI-Custom-Scripts/js/systemNotification.js",
  "/extensions/ComfyUI-Custom-Scripts/js/presetText.js",
  "/extensions/ComfyUI-Custom-Scripts/js/swapResolution.js",
  // "/extensions/ComfyUI-Custom-Scripts/js/betterCombos.js",
  // "/extensions/ComfyUI-Custom-Scripts/js/faviconStatus.js",
  "/extensions/ComfyUI-Custom-Scripts/js/useNumberInputPrompt.js",
  "/extensions/ComfyUI-Custom-Scripts/js/workflowImage.js",
  "/extensions/ComfyUI-Custom-Scripts/js/customColors.js",
  // "/extensions/ComfyUI-Custom-Scripts/js/locking.js",
  "/extensions/ComfyUI-Custom-Scripts/js/modelInfo.js",
  "/extensions/ComfyUI-Custom-Scripts/js/showText.js",
  "/extensions/ComfyUI-Custom-Scripts/js/mathExpression.js",
  "/extensions/ComfyUI-Custom-Scripts/js/nodeFinder.js",
  // "/extensions/ComfyUI-Custom-Scripts/js/workflows.js",
  "/extensions/ComfyUI-Custom-Scripts/js/snapToGrid.js",
  "/extensions/ComfyUI-Custom-Scripts/js/graphArrange.js",
  "/extensions/ComfyUI-Custom-Scripts/js/stringFunction.js",
  "/extensions/ComfyUI-Custom-Scripts/js/widgetDefaults.js",
  "/extensions/ComfyUI-Custom-Scripts/js/linkRenderMode.js",
  "/extensions/ComfyUI-Custom-Scripts/js/showImageOnMenu.js",
  "/extensions/ComfyUI-Custom-Scripts/js/kSamplerAdvDenoise.js",
  "/extensions/ComfyUI-Custom-Scripts/js/reroutePrimitive.js",
  "/extensions/ComfyUI-Custom-Scripts/js/imageFeed.js",
  "/extensions/ComfyUI-Custom-Scripts/js/assets/canvas2svg.js",
  "/extensions/ComfyUI-Custom-Scripts/js/common/utils.js",
  "/extensions/ComfyUI-Custom-Scripts/js/common/spinner.js",
  "/extensions/ComfyUI-Custom-Scripts/js/common/modelInfoDialog.js",
  "/extensions/ComfyUI-Custom-Scripts/js/common/binding.js",
  "/extensions/ComfyUI-Custom-Scripts/js/common/autocomplete.js",
  "/extensions/ComfyUI-Custom-Scripts/js/common/lightbox.js",
  // "/extensions/comfyui-nodes-docs/utils.js",
  // "/extensions/comfyui-nodes-docs/marked.js",
  // "/extensions/comfyui-nodes-docs/constants.js",
  // "/extensions/comfyui-nodes-docs/settings.js",
  // "/extensions/comfyui-nodes-docs/creatDocsElement.js",
  // "/extensions/comfyui-nodes-docs/index.js",
  "/extensions/ComfyUI-UVR5/js/uploadAudio.js",
  "/extensions/ComfyUI-UVR5/js/previewAudio.js",
  "/extensions/ComfyUI-BiRefNet-Hugo/BiRefNet_Hugo.js",
  "/extensions/comfy-easy-grids/easyGridExt.js",
  "/extensions/comfy_mtb/comfy_shared.js",
  "/extensions/comfy_mtb/constant.js",
  "/extensions/comfy_mtb/curve_widget.js",
  "/extensions/comfy_mtb/debug.js",
  "/extensions/comfy_mtb/imageFeed.js",
  "/extensions/comfy_mtb/mtb_input_output_sidebar.js",
  "/extensions/comfy_mtb/mtb_sidebar.js",
  "/extensions/comfy_mtb/mtb_ui.js",
  "/extensions/comfy_mtb/mtb_widgets.js",
  "/extensions/comfy_mtb/note_plus.constants.js",
  "/extensions/comfy_mtb/note_plus.js",
  "/extensions/comfy_mtb/notify.js",
  "/extensions/comfy_mtb/numberInput.js",
  // "/extensions/comfy_mtb/extern/shodown.min.js",
  "/extensions/comfy_mtb/extern/dom-purify.js",
  "/extensions/comfy_mtb/extern/parse-css.js",
  "/extensions/ComfyUI_RyanOnTheInside/pitch_extension.js",
  "/extensions/ComfyUI_RyanOnTheInside/midi_extensions.js",
  "/extensions/ComfyUI_RyanOnTheInside/piano.js",
  "/extensions/ComfyUI_RyanOnTheInside/help_popup.js",
  "/extensions/ComfyUI_essentials/DisplayAny.js",
  "/extensions/ComfyUI_essentials/FluxAttentionSeeker.js",
  "/extensions/komojini-comfyui-nodes/status_viewer.js",
  "/extensions/komojini-comfyui-nodes/utils.js",
  "/extensions/komojini-comfyui-nodes/komojini.core.js",
  "/extensions/komojini-comfyui-nodes/comfy_shared.js",
  "/extensions/komojini-comfyui-nodes/videoinfo.js",
  "/extensions/komojini-comfyui-nodes/komojini_widgets.js",
  "/extensions/komojini-comfyui-nodes/komojini.chain.js",
  "/extensions/komojini-comfyui-nodes/widgethider.js",
  "/extensions/komojini-comfyui-nodes/extension_template.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/gpt_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/clipInterrogator_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/checkVersion_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/ui_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/video_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/td_background.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/layer_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/common.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/p5.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/svg_icons.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/visualization.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/3d_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/watcher_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/chat.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/prompt_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/main_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/saveTripoSrMesh.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/smart_connect.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/audio_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/utils_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/image_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/app_mixlab.js",
  // "/extensions/comfyui-mixlab-nodes/javascript/sound-lab.js",
  // "/extensions/comfyui-mixlab-nodes/lib/juxtapose.min.js",
  // "/extensions/comfyui-mixlab-nodes/lib/photoswipe.esm.min.js",
  // "/extensions/comfyui-mixlab-nodes/lib/model-viewer.min.js",
  // "/extensions/comfyui-mixlab-nodes/lib/filerobot-image-editor.min.js",
  // "/extensions/comfyui-mixlab-nodes/lib/showdown.min.js",
  // "/extensions/comfyui-mixlab-nodes/lib/photoswipe-lightbox.esm.min.js",
  // "/extensions/comfyui-mixlab-nodes/lib/pickr.min.js",
  "/extensions/SenseVoice-ComfyUI/innerText.js",
  "/extensions/comfyui-fitsize/widgets.js",
  "/extensions/comfyui-prompt-reader-node/extractorDisplay.js",
  "/extensions/comfyui-prompt-reader-node/loaderDisplay.js",
  "/extensions/comfyui-prompt-reader-node/utils.js",
  "/extensions/comfyui-prompt-reader-node/seedGen.js",
  "/extensions/comfyui-prompt-reader-node/parameterDisplay.js",
  "/extensions/comfyui-prompt-reader-node/promptDisplay.js",
  "/extensions/comfyui-ollama/js/OllamaNode.js",
  "/extensions/custom_add_widgets/inject_widgets.js",
]